import Image from "next/image";

import { Text } from "@/components/text/text.component";

import { urlFor } from "@/sanity/utils";

export function RichTextImage({ value }: RichTextImageProps) {
  const imageUrl = value?.url
    ? value.url
    : value?.asset
      ? urlFor({ _type: "image", asset: value.asset }).width(1600).url()
      : null;
  if (!imageUrl || !value) return null;

  const alt = value.alt?.trim() || value.caption?.trim() || "";

  return (
    <figure className="my-8 flex justify-center" data-testid="rich-text-image">
      <Image
        src={imageUrl}
        alt={alt}
        width={1600}
        height={900}
        className="h-auto w-auto max-w-[300px] rounded-2xl"
        sizes="(max-width: 1023px) 100vw, 48rem"
      />
      {value.caption ? (
        <figcaption className="mt-2">
          <Text
            variant="body4"
            component="span"
            className="text-greyscale-body">
            {value.caption}
          </Text>
        </figcaption>
      ) : null}
    </figure>
  );
}

type RichTextImageProps = {
  value?: {
    asset?: { _ref?: string; _type?: string } | null;
    url?: string | null;
    alt?: string | null;
    caption?: string | null;
  } | null;
};
